"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var toggleList_1 = __importDefault(require("../commands/toggleList"));

var Node_1 = __importDefault(require("./Node"));

var CheckboxList = /*#__PURE__*/function (_Node_1$default) {
  _inherits(CheckboxList, _Node_1$default);

  var _super = _createSuper(CheckboxList);

  function CheckboxList() {
    _classCallCheck(this, CheckboxList);

    return _super.apply(this, arguments);
  }

  _createClass(CheckboxList, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return {
        "Shift-Ctrl-7": toggleList_1.default(type, schema.nodes.checkbox_item)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return function () {
        return toggleList_1.default(type, schema.nodes.checkbox_item);
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [prosemirror_inputrules_1.wrappingInputRule(/^-?\s*(\[ \])\s$/i, type)];
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.renderList(node, "  ", function () {
        return "- ";
      });
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "checkbox_list"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "checkbox_list";
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        group: "block",
        content: "checkbox_item+",
        toDOM: function toDOM() {
          return ["ul", {
            class: _this.name
          }, 0];
        },
        parseDOM: [{
          tag: "[class=\"".concat(this.name, "\"]")
        }]
      };
    }
  }]);

  return CheckboxList;
}(Node_1.default);

exports.default = CheckboxList;